<template>
    <div v-if="visible">
        <Modal v-model="show"
               :title="$t('下载任务')"
               :mask-closable="false"
               footer-hide
               @on-cancel="cancel"
               width="1000">
            <p slot="header">
                {{$t('下载任务')}}
                <Tooltip placement="right"
                         v-if="!!retentionTime"
                         theme="light">
                    <i class="icon-prompt-1-o tips-style"
                       style="padding-left: 10px;"></i>
                    <div slot="content">
                        <span>{{$t('文件保留时间')}}</span>
                        {{retentionTime}}
                        <span>{{$t('个月')}}</span>
                    </div>
                </Tooltip>
            </p>
            <rcTable ref="rcTable"
                     v-if="tableLoading"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o"></i>
                </Button>
                <div slot="tootipR">
                    <DatePicker v-model="newDate"
                                type="datetimerange"
                                :dateOptions="dateOptions"
                                :clearable="false"
                                :editable='false'
                                placement="bottom-end"
                                :placeholder="$t('选择日期')"
                                format="yyyy-MM-dd HH:mm:ss"
                                @on-ok="dateChange"
                                @on-clear="dateClear"
                                transfer
                                style="width: 355px" />
                </div>
            </rcTable>
        </Modal>
    </div>
</template>
<script>
import rcTable from '@/views/components/basic/rcTable'
import { formatDateTime } from '@/service/utils'
import API from '@/service/api'
export default {
    name: 'downloadTaskModal',
    components: {
        rcTable
    },
    props: {
        visible: Boolean,
        type: String
    },
    data () {
        return {
            show: false,
            tableLoading: false,
            newDate: [],
            dateOptions: {
                shortcuts: [
                    {
                        text: '1' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 1)
                            return [start, end]
                        }
                    },
                    {
                        text: '12' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 12)
                            return [start, end]
                        }
                    },
                    {
                        text: '1' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            return [start, end]
                        }
                    },
                    {
                        text: '7' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            return [start, end]
                        }
                    }
                ]
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.BILLS_DOWNLOAD_LIST),
                    params: {
                        operationType: ''
                    }
                },
                searchShow: false,
                columns: [
                    {
                        title: this.$t('任务编号'),
                        key: 'downloadNum',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        width: 120,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.downloadNum } }, params.row.downloadNum || '--')
                    },
                    {
                        title: this.$t('文件名称'),
                        key: 'fileName',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        // width: 120,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.fileName } }, this.$t(params.row.fileName) || '--')
                    },
                    {
                        title: this.$t('提交时间'),
                        key: 'createdDt',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        width: 120,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt || '--')
                    },
                    {
                        title: this.$t('操作用户'),
                        key: 'createdBy',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        width: 120,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.createdBy } }, params.row.createdBy || '--')
                    },
                    {
                        title: this.$t('生成状态'),
                        key: 'status',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const { status, remark } = params.row
                            const isFail = status === 4
                            const comp = isFail ? 'syncpoptip' : 'statusview'
                            const statusObj = {
                                1: '生成成功',
                                2: '生成中',
                                3: '已过期',
                                4: '生成失败'
                            }
                            const str = statusObj[status] || '--'
                            return h(comp, {
                                props: isFail ? {
                                    value: str,
                                    isStatic: true,
                                    errMsg: remark
                                } : { state: String(status), stateName: str }
                            })
                        }
                    },
                    {
                        title: this.$i18n.t('操作'),
                        width: 70,
                        render: (h, params) => {
                            const { status } = params.row
                            const isSuc = status === 1
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    class: { 'disabled-per': !isSuc },
                                    on: { click: () => isSuc && this.downLoad(params.row) }
                                }, this.$t('下载'))
                            ])
                        }
                    }
                ]
            },
            retentionTime: ''
        }
    },
    methods: {
        init () {
            this.tableAttr.source.params = {
                operationType: this.type
            }
            this.getRetentiontime()
            this.tableLoading = true
        },
        dateChange () {
            // 选择时间
            this.refresh(Object.assign(this.tableAttr.source.params, {
                startTime: this.newDate[0] ? formatDateTime(this.newDate[0]) : '',
                endTime: this.newDate[1] ? formatDateTime(this.newDate[1]) : ''
            }))
        },
        dateClear () {
            this.newDate = [null, null]
            this.dateChange()
        },
        downLoad (item) {
            const { downloadNum, operationType } = item
            this.axios.get(this.urlFormat(`${API.BILLS_DOWNLOAD}?num=${encodeURIComponent(this.$encrypt(downloadNum))}&operationType=${operationType}`), {
                responseType: 'blob'
            }).then(res => {
                if (res) {
                    // 文件下载
                    // const blob = new Blob([res], {
                    //     type: 'application/vnd.ms-excel'
                    // })
                    // let link = document.createElement('a')
                    // link.href = URL.createObjectURL(blob)
                    // link.setAttribute('download', fileName)
                    // link.click()
                    // link = null
                    this.$Message.success(this.$t('导出成功'))
                    this.loading = false
                }
            })
        },
        refresh (data) {
            data.operationType = this.type
            this.$refs.rcTable.refreshTable(data, true)
        },
        cancel () {
            this.newDate = []
            this.$emit('cancel')
        },
        // 文件清理时间配置
        getRetentiontime () {
            this.axios.get(this.urlFormat(API.GET_ALL_CONFIG, true), { params: { configType: 'bill_retention_time_config' } }).then(res => {
                this.retentionTime = res && res[0].configValue
            })
        }
    },
    watch: {
        visible (val) {
            val && this.init()
            this.$nextTick(() => {
                this.show = val
            })
        }
    }
}
</script>
